import { transformComponent } from '../../__builtins__/shared'
import { connect, mapProps } from '@formily/vue'
import RouterPicker from './Layout.vue'
const TransformRouterPicker = transformComponent(RouterPicker, {
  change: 'input',
})

export const DatePicker = connect(TransformRouterPicker, mapProps({ readOnly: 'readonly' }))

export default DatePicker
